import p from './pasteHere';

export * from './pasteHere';
export default p;
